import * as React from 'react';

import type {
    HiveBranchPresence,
    HiveDataSyncPresence,
    HiveDocumentPresence,
    HiveWorkingBranch,
    HiveWorkingDocument,
} from '@gitbook/hive-client';

/**
 * List other participants in a branch datasync.
 */
export function useHivePresences(
    sync: HiveWorkingDocument
): Array<HiveDataSyncPresence<HiveDocumentPresence>>;
export function useHivePresences(
    sync: HiveWorkingBranch
): Array<HiveDataSyncPresence<HiveBranchPresence>>;
export function useHivePresences(
    sync: HiveWorkingBranch | HiveWorkingDocument
): Array<HiveDataSyncPresence<HiveDocumentPresence | HiveBranchPresence>> {
    const dataSync = sync.dataSync;

    const subscription = React.useMemo(() => {
        return {
            getCurrentValue: () => {
                return dataSync.presences;
            },
            subscribe: (callback) => {
                return dataSync.listen('presences', callback);
            },
        };
    }, [dataSync]);

    const allPresences = React.useSyncExternalStore(
        subscription.subscribe,
        subscription.getCurrentValue
    );

    return React.useMemo(() => {
        // Filter out inactive presences that are empty objects
        return allPresences.filter((presence) => !!presence.data.userId);
    }, [allPresences]);
}
